import { Box, Typography, TextField, InputAdornment, Select, MenuItem } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useJobEventsController } from "../hooks/useJobEventController";

interface JobEventsHeaderProps {
  title?: string;

  search: string;
  onSearchChange: (value: string) => void;

  sort: string;
  onSortChange: (value: string) => void;
}

export function JobEventsHeader({ title = "Visits", search, onSearchChange, sort, onSortChange }: JobEventsHeaderProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 2,
      }}
    >
      {/* Left */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          color: "text.primary",
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </Typography>

      {/* Right */}
      <Box
        sx={{
          display: "flex",
          gap: 2,
          alignItems: "center",
        }}
      >
        {/* Sorting */}
        <Select
          size="small"
          value={sort}
          onChange={(e) => onSortChange(e.target.value)}
          sx={{
            minWidth: 190,
            backgroundColor: "background.paper",
          }}
        >
          <MenuItem value="upcoming">Sort: Upcoming First</MenuItem>

          <MenuItem value="past">Sort: Past First</MenuItem>
        </Select>

        {/* Search */}
        <TextField
          size="small"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search workforce or event..."
          sx={{ width: 260 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </Box>
  );
}

export type JobEventsController = ReturnType<typeof useJobEventsController>;
